import React, { Component } from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as AuthActions } from "store/ducks/auth";

import { Access } from "common";

class Menu extends Component {
  state = {
    open: false,
    submenus: {
      help: false,
    },
  };

  handleToggle = () => {
    const { open } = this.state;

    this.setState({ open: !open });
  };

  handleClose = () => {
    setTimeout(() => this.setState({ open: false }), 300);
  };

  handleToggleSubmenu = (submenu, e) => {
    e.preventDefault();

    const { submenus } = this.state;

    this.setState({ submenus: { ...submenus, [submenu]: !submenus[submenu] } });
  };

  handleLogout = (e) => {
    e.preventDefault();

    this.props.logoutRequest();
  };

  render() {
    const { open } = this.state;

    return (
      <nav id="nav" className="hide-on-print">
        <button
          className="nav-collapse"
          onClick={this.handleToggle}
          onBlur={this.handleClose}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        {open && (
          <ul id="menu">
            <li>
              <Link to="/">Home</Link>
            </li>

            {Access.hasPermissions([
              "manage-report-ranking-points",
              "manage-report-ranking-registers",
              "manage-report-provisioned-vouchers",
              "manage-events-attendance",
              "manage-report-provisioned-points",
              "manage-report-average-tickets",
              "manage-report-points",
              "manage-report-benefits",
            ]) && (
              <li>
                <Link to="/reports">Relatórios</Link>
              </li>
            )}

            {Access.hasPermissions([
              "manage-vouchers",
              "manage-channels",
              "manage-product-types",
              "manage-payment-methods",
              "manage-places",
            ]) && (
              <li>
                <Link to="/points">Pontos</Link>

                <ul className="submenu">
                  {Access.hasPermissions("manage-vouchers") && (
                    <li>
                      <Link to="/points/vouchers">
                        Lista de Vouchers (Pontos)
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link to="/">Campanha de Pontos</Link>
                  </li>
                  {Access.hasPermissions("manage-channels") && (
                    <li>
                      <Link to="/points/channels">Canais</Link>
                    </li>
                  )}
                  {Access.hasPermissions("manage-product-types") && (
                    <li>
                      <Link to="/points/products-types">Tipos de Produtos</Link>
                    </li>
                  )}
                  {Access.hasPermissions("manage-payment-methods") && (
                    <li>
                      <Link to="/points/payments">Meios de Pagamento</Link>
                    </li>
                  )}
                  {Access.hasPermissions("manage-places") && (
                    <li>
                      <Link to="/points/stores">Lojas</Link>
                    </li>
                  )}

                  {Access.hasPermissions("manage-prizes") && (
                    <li>
                      <Link to="/points/prizes">Premiação</Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {Access.hasPermissions("manage-benefits") && (
              <li>
                <Link to="/benefits">Benefícios</Link>

                <ul className="submenu">
                  <li>
                    <Link to="/benefits/list">Lista de Benefícios</Link>
                  </li>
                  <li>
                    <Link to="/benefits">Tipos de Benefícios</Link>
                  </li>
                </ul>
              </li>
            )}

            {Access.hasPermissions("manage-events") && (
              <li>
                <Link to="/events">Eventos</Link>

                <ul className="submenu">
                  <li>
                    <Link to="/events/list">Lista de Eventos</Link>
                  </li>
                  <li>
                    <Link to="/events">Tipos de Eventos</Link>
                  </li>
                </ul>
              </li>
            )}

            {Access.hasPermissions([
              "edit-messages",
              "edit-users",
              "edit-access-groups",
              "edit-permissions",
              "edit-variables",
              "edit-log",
              "edit-incidents",
            ]) && (
              <li>
                <Link to="/configs">Configurações Gerais</Link>
              </li>
            )}

            {Access.hasPermissions([
              "manage-inhabitant-segments",
              "view-inhabitant-segments",
              "view-cashback-imports",
              "manage-cashback-imports",
            ]) && (
              <li>
                <Link to="/pro">PRO</Link>

                <ul className="submenu">
                  {Access.hasPermissions([
                    "manage-inhabitant-segments",
                    "view-inhabitant-segments",
                  ]) && (
                    <li>
                      <Link to="/pro/list">Listagem de Clientes PRO</Link>
                    </li>
                  )}

                  {Access.hasPermissions([
                    "view-cashback-imports",
                    "manage-cashback-imports",
                  ]) && (
                    <li>
                      <Link to="/pro/cashback/list">Listagem de Cashbacks</Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            <li>
              <a href="/#" className="logout" onClick={this.handleLogout}>
                Sair
              </a>
            </li>
          </ul>
        )}
      </nav>
    );
  }
}

const mapState = (state) => ({ auth: state.auth });

const mapActions = (dispatch) => bindActionCreators(AuthActions, dispatch);

export default connect(mapState, mapActions)(Menu);
